module.exports = __webpack_public_path__ + "img/c958a4a.jpg";